module.exports = __webpack_public_path__ + "img/brand-capital.dc9fab55.svg";